import { render, staticRenderFns } from "./si_Stars.vue?vue&type=template&id=1cfbaed4&scoped=true&"
import script from "./si_Stars.vue?vue&type=script&lang=js&"
export * from "./si_Stars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfbaed4",
  null
  
)

export default component.exports